import { DateTime } from "luxon"

import DigesterHeader from "@/features/feedstock/components/DigesterHeader"
import FeedstockTable from "@/features/feedstock/components/FeedstockTable"

export default function Digesters() {
  return (
    <>
      <DigesterHeader />
      <FeedstockTable
        config={{
          startDate: DateTime.now().minus({ months: 11 }).startOf("month").toISODate(),
          endDate:
            DateTime.now()
              .setZone("America/Chicago")
              .startOf("day")
              .minus({ days: 1 })
              .toISODate() || "",
          kpi: {
            $type: "basic",
            id: 45,
            location: 2,
            dimension: "digester",
          },
          dimension: "digester",
          groups: [
            {
              name: "Pod 1",
              entities: [
                {
                  name: "501",
                  dimensionKey: 501,
                },
                {
                  name: "502",
                  dimensionKey: 502,
                },
                {
                  name: "503",
                  dimensionKey: 503,
                },
                {
                  name: "504",
                  dimensionKey: 504,
                },
              ],
            },
            {
              name: "Pod 2",
              entities: [
                {
                  name: "505",
                  dimensionKey: 505,
                },
                {
                  name: "506",
                  dimensionKey: 506,
                },
                {
                  name: "507",
                  dimensionKey: 507,
                },
                {
                  name: "508",
                  dimensionKey: 508,
                },
              ],
            },
            {
              name: "Pod 3",
              entities: [
                {
                  name: "509",
                  dimensionKey: 509,
                },
                {
                  name: "510",
                  dimensionKey: 510,
                },
                {
                  name: "511",
                  dimensionKey: 511,
                },
                {
                  name: "512",
                  dimensionKey: 512,
                },
              ],
            },
            {
              name: "Pod 4",
              entities: [
                {
                  name: "513",
                  dimensionKey: 513,
                },
                {
                  name: "514",
                  dimensionKey: 514,
                },
                {
                  name: "515",
                  dimensionKey: 515,
                },
                {
                  name: "516",
                  dimensionKey: 516,
                },
              ],
            },
          ],
          bounds: [
            { lower: 0, upper: 75000, class: "text-status-warn" },
            { lower: 75000, upper: 80000, class: "text-status-good" },
            { lower: 80000, class: "text-status-bad" },
          ],
        }}
      />
    </>
  )
}
